import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import Headline from '../../../components/headline/Headline'
import debounce from 'lodash/debounce';
import { post, Token } from '../../../Script/Session';
import { Autocomplete, Link, Table } from '@mui/joy';
import { useNavigate } from 'react-router-dom';



function RegionalgruppenView() {
    const [wit, setwith] = useState("90.5%");
    const [searchTerm, setSearchTerm] = useState();
    const [users, setusers] = useState();
    const [reggroups, setreggroups] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        setusers(JSON.parse(response));
    }, []);
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setreggroups(JSON.parse(response));
    }, []);
    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                <Headline title={"Regionalgruppen"} />
                <Autocomplete sx={{mt: 4, mb: 2}} onChange={(e, newv) => {
                    setSearchTerm(newv)
                    console.log(newv);
                }

                } options={reggroups?.result || []} getOptionLabel={(item) => item.name} placeholder='Regionalgruppe' />

                <Table>
                    <thead>
                        <th>Name</th>
                    </thead>
                    <tbody>
                        {
                            searchTerm && users && users.result && users.result.slice().filter((item) => item.reggruppe == searchTerm.name).map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td><Link href={window.location.origin + "/my-profile/" + item.id}>{item.name}</Link></td>
                                    </tr>
                                )

                            })
                        }



                    </tbody>
                </Table>



            </div>
            <NavigationBar state={"profile"} back={true} />
        </>
    )
}

export default RegionalgruppenView
